import fetcher from 'api/fetcher';

import { Quiz, setQuizData, setQuizVisible } from 'store/models/quiz';
import { AppThunkAction } from 'store/utils';

export const fetchQuiz = (): AppThunkAction => {
    return (dispatch) => {
        return fetcher.get<unknown, Quiz | null>('/api/v1/quiz/getActualQuiz').then((quiz) => {
            if (quiz) {
                dispatch([setQuizData(quiz), setQuizVisible(true)]);
            }
        });
    };
};
